module.exports = __webpack_public_path__ + "img/LGPD.0e57e5d4.png";